import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { TEST_LOCATORS } from '@src/constants/test-locators'

import { default as Button, BUTTON_TYPES } from '../button'

import styles from './productForm.module.scss'

import type { MouseEvent } from 'react'

export interface SizeChartButtonProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  isStandalone?: boolean
}

const SizeChartButtonLegacy = ({ onClick, isStandalone }: SizeChartButtonProps) => {
  const { t } = useTranslation('common')
  return (
    <Button
      type={BUTTON_TYPES.SECONDARY_LINK}
      onClick={onClick}
      className={classnames(styles.container__label__sizeChart, styles.container__label__sizeChart_adjustedPadding, {
        [styles.sizeChart_newDesignV2 ?? '']: true,
        [styles.sizeChart_show ?? '']: true,
        [styles.sizeChart_standalone ?? '']: isStandalone,
      })}
      id={TEST_LOCATORS.SIZE_CHART_BUTTON}
    >
      {t('size_chart')}
    </Button>
  )
}

export default SizeChartButtonLegacy
